import React from "react";
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Select, Table, Icon, Badge, Modal, notification} from 'antd';
import BudgetList from "./budget/BudgetList";
import BudgetEdit from "./budget/BudgetEdit";


const Option = Select.Option;
const uri_budget = URI_SETUP+"budget";

class Budget extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_active              : "budget-list",
            budget_list                 : [],
            budget_lst_rows             : [],
            reference_years             : [],
            budget_selected             : null,
            modal_delete_item           : false,
            modal_set_live              : false,
            modal_set_offline           : false,
            status_remove_item_modal    : "hide",
            active_budget               : {
                                            period              : "",
                                            year                : "",
                                            reference_year      : "",
                                            depth               : "",
                                            capture_format      : "",
                                            expected_growth     : 0,
                                            growth              : 0,
                                            matrix              : [],
                                            status              : "default",
                                            active_budget       : false
                                        }
            }
        this.setActiveBudgetSection = this.setActiveBudgetSection.bind(this);
        this.updateActiveBudget = this.updateActiveBudget.bind(this);
        this.resetActiveBudget = this.resetActiveBudget.bind(this);
    }

    componentWillMount(){
        this.startBudgetSetup();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hotel_selected != this.props.hotel_selected) {
            this.startBudgetSetup();
            this.resetActiveBudget();
            this.setActiveBudgetSection("budget-list");
        }
    }

    // ----------------------- Handlers -----------------------

    handleNewBudget(e) {
        let self = this;
        e.preventDefault();
        self.resetActiveBudget();
        self.setActiveBudgetSection("budget-edit");
    }

    HandlerBudgetEdit(row){
        let self = this;
        self.setState({ 
            active_budget : row
            })
        self.setActiveBudgetSection("budget-edit");
    }

    handleRemoveItem(_id) {
        let self = this;
        self.setState({ 
            modal_delete_item               : true,
            budget_selected             : _id
            })
        
    }

    handleSetLiveItem(_id) {
        let self = this;
        self.setState({ 
            modal_set_live                  : true,
            budget_selected             : _id
            })  
    }

    handleConfirmSetOfflineModal(_id) {
        let self = this;
        self.setState({ 
            modal_set_offline                : true,
            budget_selected             : _id
            })  
    }

    handleConfirmSetOffline = e => {
        let formData = new FormData();
        this.setState({ modal_set_offline : false });

        notification.open({
            message: 'Notification',
            description: "We started to remove the Budget data of your MagnumLeap panels."
          });
        
        formData.append('api_token',localStorage.getItem("api_token"));
        formData.append('mode',"set_as_offline");

        axios.post(uri_budget+"/"+this.state.budget_selected+"/destroy", formData)
                    .then(request => {
                        let budget_lst_rows=this.mapBudgetRows(request.data)
                        this.setState({     
                            budget_lst_rows                 : budget_lst_rows,
                            budget_list                     : request.data
                        });
                        notification.open({
                            message: 'Notification',
                            description: "This action was successfully completed."
                          }); 
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Process Unsuccessful please try again"
                          });
                    });
        this.setState({
            budget_selected   : null
        });
        
      };


    handleConfirmSetLive = e => {
        let formData = new FormData();

        notification.open({
            message: 'Notification',
            description: "Action in progress, you can verify the progress in the notiication bar"
          });

        formData.append('api_token',localStorage.getItem("api_token"));
        formData.append('mode',"set_as_visible");

        axios.post(uri_budget+"/"+this.state.budget_selected, formData)
                    .then(request => {
                        this.startBudgetSetup(); 
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message
                          });
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Process Unsuccessful please try again"
                          });
                    });
        this.setState({
            modal_set_live        : false,
            budget_selected   : null
        });
        
      };
    
      handleCancelSetLive = e => {
        this.setState({
            modal_set_live        : false,
            budget_selected   : null
        });
      };

      handleCancelSetOffline = e => {
        this.setState({
            modal_set_offline        : false,
            budget_selected   : null
        });
      };

    // ----------------------- Functions -----------------------

    resetActiveBudget(){
        let self = this;
        self.setState({ 
            active_budget    : {
                                period              : "",
                                year                : 0,
                                reference_year      : 0,
                                depth               : "",
                                capture_format      : "",
                                expected_growth     : 0,
                                growth              : 0,
                                active_budget       : false,
                                matrix              : [],
                                status              : "default"
                            }
            })
    }
    
    updateActiveBudget(active_budget){
        let self = this;
        self.setState({ 
            active_budget      : active_budget
            })
    }

    startBudgetSetup(){
        let self = this;
        axios.get(uri_budget, { 
            params: {
                api_token       : localStorage.getItem("api_token"),
                mode            : "define",
                property_id     : self.props.hotel_selected
            }
        }).then(request => { 
            let budget_lst_rows=self.mapBudgetRows(request.data.budget_list)
            self.setState({ 
                budget_list                : request.data.budget_list,
                budget_lst_rows            : budget_lst_rows,
                reference_years            : request.data.reference_years,
            }) 
        })
    }

    mapBudgetRows(budget_list){
        let maped_rows=[];
        let maped_row=[];
        let self=this;
        budget_list.map(function(row, i) {
            maped_row={
                key                     : i,
                _id                     : row._id,
                year                    : <span><Badge status={row.status} /> {row.year}</span>,
                created_by              : row.created_by.name,
                period                  : row.period,
                growth                  : row.growth,
                depth                   : row.depth,
                capture_format          : row.capture_format,
                reference_year          : row.reference_year,
                created_at              : row.created_at.substring(0,10),
                actions                 : <div>
                                            <i className="fa fa-pencil edit clickable" onClick={self.HandlerBudgetEdit.bind(self,row)} ></i> 
                                            <i className="fa fa-upload live clickable" onClick={self.handleSetLiveItem.bind(self,row._id)} ></i>
                                            <i className="fa fa-times-circle remove clickable" onClick={self.handleConfirmSetOfflineModal.bind(self,row._id)} ></i> 
                                            <i className="fa fa-trash remove clickable" onClick={self.handleRemoveItem.bind(self,row._id)} ></i> 
                                          </div>
                
            };
            maped_rows.push(maped_row);
            });
        return maped_rows;
    }
    
    setActiveBudgetSection(section){
        let self = this;
        self.setState({ 
            section_active      : section
            })
    }

    confirmItemDeletion = e => {

        let formData = new FormData();
        this.setState({ modal_delete_item : false });

        notification.open({
            message: 'Notification',
            description: "Magnum Leap started the Budget remove process"
          });
        
        formData.append('api_token',localStorage.getItem("api_token"));

        axios.post(uri_budget+"/"+this.state.budget_selected+"/destroy", formData)
                    .then(request => {
                        let budget_lst_rows=this.mapBudgetRows(request.data)
                        this.setState({     
                            budget_lst_rows                 : budget_lst_rows,
                            budget_list                     : request.data
                        });
                        notification.open({
                            message: 'Notification',
                            description: "This action was successfully completed."
                          }); 
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Process Unsuccessful please try again"
                          });
                    });
        this.setState({
            budget_selected   : null
        });
        
    }

    cancelConfirmItemDeletion = e => {
        this.setState({
            modal_delete_item        : false,
            production_selected      : null
        });
      };

    // ----------------------- Renders -----------------------

    renderConfirmSetLive() {
        return (
            <Modal
              title="Confirm"
              visible={this.state.modal_set_live}
              onOk={this.handleConfirmSetLive}
              onCancel={this.handleCancelSetLive}
            >
              <p>Are you sure?. If you confirm this action, the selected data going to replace the actual one.</p>
            </Modal>
        );
      }

    renderConfirmSetOffiline() {
    return (
        <Modal
            title="Confirm"
            visible={this.state.modal_set_offline}
            onOk={this.handleConfirmSetOffline}
            onCancel={this.handleCancelSetOffline}
        >
            <p>Are you sure?. The actual Budget data for this year in MagnumLeap panels going to be lost.</p>
        </Modal>
    );
    }

    renderConfirmItemDeletion() {
    return (
        <Modal
            title="Confirm"
            visible={this.state.modal_delete_item}
            onOk={this.confirmItemDeletion}
            onCancel={this.cancelConfirmItemDeletion}
        >
            <p>Are you sure?. All the information of this Budget going to be removed.</p>
        </Modal>
    );
    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                                <div className="col col-md-3">
                                    <button className={"blue " + this.state.status_new_budget} onClick={this.handleNewBudget.bind(this)} >NEW BUDGET</button>
                                </div>
                            </div>
                    </div>
                   
                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Budget</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>Now, manage your sales budget, </strong> <br/> If you already have historical reservations information, Magnum Leap helps you with relevant data to setup your next year budget, you can set up by different periods divided by segment or agency. </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12"> 
                        <div className="layout-budget">
                            { this.state.section_active == "budget-list" &&
                            <div className={"budget-list "}>
                                <BudgetList
                                    setActiveBudgetSection = {this.setActiveBudgetSection}
                                    app={this}
                                    handleNotification = {this.props.handleNotification}
                                    
                                    
                                />
                            </div>
                            }
                            { this.state.section_active == "budget-edit" &&
                            <div className={"budget-edit "}>
                                <BudgetEdit
                                    setActiveBudgetSection = {this.setActiveBudgetSection}
                                    updateActiveBudget = {this.updateActiveBudget}
                                    resetActiveBudget  = {this.resetActiveBudget}
                                    app={this}
                                    active_budget = {this.state.active_budget}
                                    hotel_selected = {this.props.hotel_selected}
                                    handleNotification = {this.props.handleNotification}
                                    
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>

                { this.renderConfirmItemDeletion()}
                { this.renderConfirmSetLive() }
                { this.renderConfirmSetOffiline() }

            </section>
        )
    }

}

export default Budget


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Budget.js